import styled, { css } from 'styled-components';

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const Headings = styled.div`
    ${({ theme }) => css`
        display: none;
        font-weight: bold;

        @media ${theme.breakpoints.medium.media} {
            margin: 0 0 1.5rem 0;
            display: grid;
            padding-right: 1.5rem;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

            *:not(:first-child, :last-child) {
                padding-left: 1.25rem;
            }
        }
    `}
`;
